import React from 'react'

export const Wrapper = ({
  children = undefined,
  atom = undefined,
  molecule = undefined,
  organism = undefined,
  marginSize = undefined,
  sidePadding = undefined,
}) => (
  <div
    style={{
      marginBottom: atom
        ? '16px'
        : molecule
          ? '48px'
          : organism
            ? '80px'
            : marginSize || '0px',
      paddingLeft: sidePadding || '0px',
      paddingRight: sidePadding || '0px',
    }}
  >
    {children}
  </div>
)
